import Header from './components/Header';
import HeroSection from './components/HeroSection';
import ContactSection from './components/ContactSection';
import AboutSection from './components/AboutSection';
import TopicsSection from './components/TopicsSection';
import MediaSection from './components/MediaSection';
import CommentsSection from './components/CommentsSection';
import CarouselSection from './components/CarouselSection';
import CardsSection from './components/CardsSection';
import RankingSection from './components/RankingSection';
import AppSection from './components/AppSection';
import FaqSection from './components/FaqSection';
import IndexSection from './components/IndexSection';
import FeaturesSection from './components/FeaturesSection';
import UpdatesSection from './components/UpdatesSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="relative min-h-screen bg-background-50">
      <Header />

      <main>
        <HeroSection />
        <ContactSection />
        <AboutSection />
        <TopicsSection />
        <MediaSection />
        <CommentsSection />
        <CarouselSection />
        <CardsSection />
        <RankingSection />
        <AppSection />
        <FaqSection />
        <IndexSection />
        <FeaturesSection />
        <UpdatesSection />
      </main>

      <Footer />
    </div>
  );
}